import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { NetworkTopThemesLoadAction } from '../../domains/networkTopThemes/actions.types';

import { NetworkTopThemesLifecycle } from './types';

const initialState: NetworkTopThemesLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<NetworkTopThemesLifecycle, NetworkTopThemesLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'NETWORK_TOP_THEMES.LOAD_PENDING':
      return setPending();
    case 'NETWORK_TOP_THEMES.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.networkTopThemes);
    case 'NETWORK_TOP_THEMES.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
